import {ResolveFn} from '@angular/router';
import {inject} from '@angular/core';
import {NotificationsService} from '@services/api-services/notifications.service';
import {Notification} from '@models/generated.model';

export const notificationResolver: ResolveFn<Notification> = (route, state) => {
  const notservice = inject(NotificationsService);
  return notservice.getNotification$(Number(<string>route.paramMap.get('id')));
};
